module.exports = __webpack_public_path__ + "img/cost-serve-phone.1d53bb2d.png";